import React, { useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom';
import { Row, Col, Container, Input, Table } from 'reactstrap';
import Switch from "react-switch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import MaterialTable from 'material-table';


//constant
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import { Navigate, useNavigate } from 'react-router-dom';
import { Link } from '@reach/router';
import { requestApi } from '../../../request-api';
import DataTable from 'react-data-table-component';
import { dataToXLS } from '../../../helpers/dataToXLS';


function Clients() {

  let [isChecked, setIsChecked] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [company, setCompany] = useState([])
  const [companyCount, setCompanyCount] = useState(0)
  const [search, setSearch] = useState("")
  const [searchClients, setSearchClients] = useState('');
  const [searchStatus, setSearchStatus] = useState('');
  let [report, setReport] = useState([]);
  let [companyFilter, setCompanyFilter] = useState([]);
  let [branchFilter, setBranchFilter] = useState([]);
  let [reportFilter, setReportFilter] = useState([]);
  let [downloadData, setDownloadData] = useState([]); 
  const [filteredSearch, setFilteredSearch] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [date, setDate] = useState([]);
  const [companyId, setCompanyId] = useState([]);
  let navigate = useNavigate()

  const [pagination, setPagination] = useState({
    skip: 0,
    limit: 500000
  })
  const downloadReport = () => {
      
          dataToXLS(downloadData, 'Clients');
      
  };

  const [columns, setColumns] = useState([
    {
      name: 'Company Name',
      selector: (row) => (
        <td className='name-eye-box'>
          {row.company_name} {' '}
          <NavLink
            className="text-decoration-none"
            onClick={(e) => {
              e.preventDefault();
              navigate(
                `${directUrl}auditor/branch-detail/${row.company_id}`,
                {
                  state: { row: row },
                }
              );
            }}
          >
            <i className="icon icon-eye"></i>
          </NavLink>
        </td>
      ),
      sortable: true,
      width:"200px",
    },
    {
      name: 'Company Id',
      selector: (row) => row.company_id,
      sortable: true,
      width:"200px",
    },
    {
      name: 'GST Number',
      selector: (row) => row.gst_number,
      sortable: true,
      width:"200px",
    },
    {
      name: 'Date of MOU',
      selector: (row) => row.date_of_mou,
      sortable: true,
      width:"150px",
    },
    {
      name: 'Office Address',
      selector: (row) => row.office_address,
      sortable: true,
      width:"200px",
    },
    {
      name: 'Phone Number',
      selector: (row) => row.phone_number,
      sortable: true,
      width:"150px",
    },
    {
      name: 'Action',
      grow: 2,
      selector: (row) => (
        <td>
          <NavLink
            className="text-decoration-none"
            to={`${directUrl}auditor/clients-edit/${row.company_id}`}
          >
            <i className="icon icon-edit-new"></i>
          </NavLink>
        </td>
      ),
    },
  ]);

  const dummy = (e) => {
     console.log(e);
     if (e.allSelected == true) {
       setDownloadData(e.selectedRows);
     } else if (e.allSelected == false && e.selectedCount == 0) {
       setDownloadData([]);
     } else if (e.selectedCount > 0) {
       setDownloadData(e.selectedRows);
     } else if (e.selectedCount == 0) {
       setDownloadData([]);
     }
    if (e.selectedCount == 0) {
      setIsChecked(false);
    }
    else {
      setIsChecked(true);
    }
  }

  useEffect(() => {

    onGetCompany();




  }, [pagination])

  useEffect(() => {
    if(search == 'empty'){
      return setFilteredSearch(company)
    }
    const result = company.filter((c) => {
      return c.company_name.toLowerCase().match(search.toLowerCase()) ||
        c.company_id.toLowerCase().match(search.toLowerCase()) ||
        c.gst_number.toLowerCase().match(search.toLowerCase()) ||
        c.phone_number.toLowerCase().match(search.toLowerCase());
    })
    setFilteredSearch(result)
  }, [search])

   useEffect(() => {
     const result = company.filter((comp) => {
       let created_date = new Date(Date.parse(comp.date_of_mou));
       let filterDate = new Date(Date.parse(startDate));
       // created_date =  created_date.getDate()
       // filterDate = filterDate.getDate();
       console.log(
         '0',
         created_date.getDate() == filterDate.getDate() &&
           created_date.getMonth() == filterDate.getMonth() &&
           created_date.getFullYear() == filterDate.getFullYear()
       );
       return (
         created_date.getDate() == filterDate.getDate() &&
         created_date.getMonth() == filterDate.getMonth() &&
         created_date.getFullYear() == filterDate.getFullYear()
       );
     });
     setFilteredSearch(result);
   }, [startDate]);


  const onGetCompany = () => {

    requestApi('/auditor/company/getCompanyById', {
      method: 'post',
      body: JSON.stringify({
        skip: pagination.skip,
        limit: pagination.limit
      })

    }).then((data) => {
      if (data.statusCode === 200) {
        let compN = []
        let compId = []
        let compDate = []

        setCompany(data.data);
        setCompanyCount(data.data.length);
        setFilteredSearch(data.data)
        setCompanyName(data.data.map((cn) => { return cn.company_name }))
        data.data.map((c) => {
          if (!compN.find((cn => cn === c.company_name))) {
            compN.push(c.company_name)
          }
          if (!compId.find((cn) => cn === c.company_id)) {
            compId.push(c.company_id);
          }
          if (!compDate.find((cn) => cn === c.date_of_mou)) {
            compDate.push(c.date_of_mou);
          }
          setCompanyName(compN)
          setCompanyId(compId)
          setDate(compDate)
        })
        console.log("data.data", companyName);
      }

    })

  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };


  return (
    <section className="lyt-section typ-min-height">
      <Container fluid className="typ-container">
        <div className="bs-card">
          <Row>
            {isChecked ? (
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="bs-action-btn">
                  <div className="button-group">
                    <a
                      className="action-btn"
                      onClick={(e) => {
                        downloadReport();
                      }}
                    >
                      {' '}
                      <span class="icon icon-download"></span>
                    </a>
                    {/* <a className="action-btn" href="">
                      {' '}
                      <span class="icon icon-share"></span>
                    </a>
                    <a className="action-btn" href="">
                      <span class="icon icon-delete"></span>
                    </a> */}
                  </div>
                </div>
              </Col>
            ) : (
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="bs-table">
                  <div className="main-header">
                    <form className="bs-form">
                      <div className="search-btn">
                        <Input
                          type="text" className='no-min-height'
                          placeholder="Search..."
                          onChange={(e) => setSearch(e.target.value)}
                        />
                        <i className="icon icon-search"></i>
                      </div>
                      <div className="dropdown-bx">
                        <label className="form-label">Company Name : </label>
                        <Input
                          type="select"
                          name="select"
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          id="exampleSelect"
                        >
                          <option value={'empty'}>Select</option>
                          {companyName.map((company) => (
                            <option key={company} value={company}>
                              {company}
                            </option>
                          ))}
                        </Input>
                      </div>
                      <div className="dropdown-bx report-date">
                        <label className="form-label">Date : </label>
                        {/* <Input type="text" name="text" id="exampleEmail" className='cstm-input' placeholder="Enter Branch ID" /> */}
                        <DatePicker
                          selected={startDate}
                          onChange={(date) => setStartDate(date)}
                          placeholderText="date"
                          className="typ-date"
                        />
                      </div>
                      {/* <div className="dropdown-bx">
                        <label className="form-label">Branch ID : </label>
                        <Input
                          type="select"
                          name="select"
                          onChange={(e) => {
                            setSearch(e.target.value);
                          }}
                          id="exampleSelect"
                        >
                          <option>HDFC</option>
                          <option>Yearly</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                        </Input>
                      </div> */}
                    </form>
                    <div className="left-button">
                      <button
                        className="bs-btn typ-white"
                        onClick={() => {
                          navigate(`${directUrl}auditor/create-company`);
                        }}
                      >
                        <span class="icon icon-plus"></span> create company
                      </button>
                      <button
                        className="bs-btn btn-submit typ-create"
                        onClick={() => {
                          navigate(`${directUrl}auditor/create-branch`);
                        }}
                      >
                        <span class="icon icon-plus"></span> create branch
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            )}
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="bs-table typ-datable border">
                <DataTable
                  columns={columns}
                  data={filteredSearch}
                  pagination
                  fixedHeader
                  fixedHeaderScrollHeight="450px"
                  selectableRows
                  onSelectedRowsChange={dummy}
                  selectableRowsHighlight
                  highlightOnHover
                />

                {/* <Table responsive>
                  <thead>
                    <tr>
                      <th>
                        <Input type="checkbox" />{' '}
                      </th>
                      <th>Sr.No.</th>
                      <th>
                        Company <span className="d-block">Name</span>
                      </th>
                      <th>Branch_ID </th>
                      <th>Office Address</th>
                      <th>Branch POC Number</th>
                      <th>
                        Assigned Complaincer{' '}
                        <span className="d-block">Officer</span>
                      </th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <Input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleOnChange}
                        />{' '}
                      </td>
                      <td>1</td>
                      <td>HDFC</td>
                      <td>
                        HDFC_Worli &nbsp;{' '}
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-eye"></i>
                        </NavLink>
                      </td>
                      <td>
                        4141 Rockside Rd Suite 410, Seven Hills, OH 44131,
                        United States
                      </td>
                      <td>Ramesh_91123456789</td>
                      <td>Saloni Parihar</td>
                      <td>
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-edit-new"></i>
                        </NavLink>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleOnChange}
                        />{' '}
                      </td>
                      <td>2</td>
                      <td>HDFC</td>
                      <td>
                        HDFC_Worli &nbsp;{' '}
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-eye"></i>
                        </NavLink>
                      </td>
                      <td>
                        4141 Rockside Rd Suite 410, Seven Hills, OH 44131,
                        United States
                      </td>
                      <td>Ramesh_91123456789</td>
                      <td>Saloni Parihar</td>
                      <td>
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-edit-new"></i>
                        </NavLink>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleOnChange}
                        />{' '}
                      </td>
                      <td>3</td>
                      <td>HDFC</td>
                      <td>
                        HDFC_Worli &nbsp;{' '}
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-eye"></i>
                        </NavLink>
                      </td>
                      <td>
                        4141 Rockside Rd Suite 410, Seven Hills, OH 44131,
                        United States
                      </td>
                      <td>Ramesh_91123456789</td>
                      <td>Saloni Parihar</td>
                      <td>
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-edit-new"></i>
                        </NavLink>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleOnChange}
                        />{' '}
                      </td>
                      <td>4</td>
                      <td>HDFC</td>
                      <td>
                        HDFC_Worli &nbsp;{' '}
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-eye"></i>
                        </NavLink>
                      </td>
                      <td>
                        4141 Rockside Rd Suite 410, Seven Hills, OH 44131,
                        United States
                      </td>
                      <td>Ramesh_91123456789</td>
                      <td>Saloni Parihar</td>
                      <td>
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-edit-new"></i>
                        </NavLink>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <Input
                          type="checkbox"
                          checked={isChecked}
                          onChange={handleOnChange}
                        />{' '}
                      </td>
                      <td>5</td>
                      <td>HDFC</td>
                      <td>
                        HDFC_Worli &nbsp;{' '}
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-eye"></i>
                        </NavLink>
                      </td>
                      <td>
                        4141 Rockside Rd Suite 410, Seven Hills, OH 44131,
                        United States
                      </td>
                      <td>Ramesh_91123456789</td>
                      <td>Saloni Parihar</td>
                      <td>
                        <NavLink className="text-decoration-none">
                          <i className="icon icon-edit-new"></i>
                        </NavLink>
                      </td>
                    </tr>
                  </tbody>
                </Table>*/}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default Clients
